export function createInitialAuthState() {
  return {
    role: "unLogin",
    afField: "",
    region: "",
    fieldId: "",
    token: "",
    user: null,
    permissions: [],
    authInitialized: false,
  };
}

export function applyLoginState(state, loginData) {
  const data = loginData || {};
  state.token = data.token || "";
  state.role = data.identity || "user";
  state.afField = data.afField || "";
  state.region = data.region || "";
  state.fieldId = data.fieldId || "";
  state.user = {
    userId: data.userId,
    account: data.account,
    identity: data.identity,
    region: data.region,
    afField: data.afField,
    fieldId: data.fieldId,
  };
  state.permissions = [];
  state.authInitialized = false;
}

export function applyCurrentUserState(state, currentUser) {
  const user = currentUser || {};
  state.user = {
    userId: user.userId,
    account: user.account,
    identity: user.identity,
    region: user.region,
    afField: user.afField,
    fieldId: user.fieldId,
  };
  state.role = user.identity || "user";
  state.afField = user.afField || "";
  state.region = user.region || "";
  state.fieldId = user.fieldId || "";
  state.permissions = Array.from(new Set(user.permissions || []));
  state.authInitialized = true;
}

export function resetAuthState(state) {
  state.role = "unLogin";
  state.afField = "";
  state.region = "";
  state.fieldId = "";
  state.token = "";
  state.user = null;
  state.permissions = [];
  state.authInitialized = true;
}
